export default {
    state: {
        onesignal_appid: '',
        permitir_notificaciones: false,
        vista_calendario: 'timeGridDay',
        access_token: '',
        refresh_token: '',
        permisos: {},
        intervalo: null,
        ubicacion: '',
        usuario: {},
        fb_login : {},
        usuario_temporal: {
            visitante_id: '',
            access_token: '',
        },
    },
    mutations: {
        establecer_telefono (state, telefono) {
            state.usuario.telefono = telefono;
        },
        establecer_onesignal_appid (state, appid) {
            state.onesignal_appid = appid;
        },
        cambiar_permitir_notificaciones (state, estado) {
            state.permitir_notificaciones = estado;
        },
        ubicacion (state, estado) {
            state.ubicacion = estado;
        },
        acceso_temporal (state, datos) {
            state.usuario_temporal = datos;
        },
        cambiar_vista_calendario (state, view) {
            state.vista_calendario = view;
        },
        guardar_permisos (state, payload) {
            state.permisos = payload;
        },
        guardar_refresh_token (state, payload) {
            state.refresh_token = payload;
        },
        guardar_access_token (state, payload) {
            state.access_token = payload;
            var claims = payload.split('.')[1];
            claims = atob(claims);
            claims = JSON.parse(claims);
            state.usuario = claims.user_claims;
        },
        cerrar_sesion (state) {
            state.refresh_token = '';
            state.access_token = '';
            state.usuario = {};
            state.permisos = {};
        },
        guarda_sesion_facebook(state, payload)
        {
            state.fb_login = payload
        },
        intervalo(state, payload)
        {
            state.intervalo = payload;
        },
    },
    actions: {},
    plugins: []
}
